import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { grayColor } from "assets/jss/elite-feats-cms";

import buttonStyle from "assets/jss/elite-feats-cms/components/buttonStyle";

const sweetAlertStyle: Record<string, CSSProperties> = {
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    color: grayColor[2],
    fontSize: "18px",
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  left: {
    textAlign: "left",
  },
  ...buttonStyle,
};

export default sweetAlertStyle;
